// extracted by mini-css-extract-plugin
module.exports = {"hScreen":"shortsDetail_hScreen__oi1rn","jwpContainer":"shortsDetail_jwpContainer__bbviF"};